import {
  createFrontendPlugin,
  PageBlueprint,
  PluginHeaderActionBlueprint,
  SubPageBlueprint,
} from '@backstage/frontend-plugin-api';
import { RiGradienterLine } from '@remixicon/react';

import { insightsRouteRef, rootRouteRef } from './routes';
import { LensPage } from './components/lens-page';

export const page = PageBlueprint.make({
  params: {
    path: '/lens',
    routeRef: rootRouteRef,
    icon: <RiGradienterLine />,
    title: 'Lens',
  },
});

export const headerActions = PluginHeaderActionBlueprint.make({
  params: defineParams =>
    defineParams({
      loader: () =>
        import('./components/header-actions').then(m => <m.HeaderActions />),
    }),
});

const insightsSubPage = SubPageBlueprint.make({
  name: 'insights',
  params: {
    path: 'insights',
    title: 'Insights',
    routeRef: insightsRouteRef,
    loader: () => Promise.resolve(<LensPage />),
  },
});

export const lensPlugin = createFrontendPlugin({
  pluginId: 'lens',
  extensions: [page, headerActions, insightsSubPage],
  routes: {
    root: rootRouteRef,
  },
});
